export default "__VITE_ASSET__ff724610__"